export const SET_DECEASED_DETAILS_ENABLED = 'SET_DECEASED_DETAILS_ENABLED'
export const setDeceasedDetailsEnabled = (enableType, payload) =>{
  return{
    type: SET_DECEASED_DETAILS_ENABLED,
    enableType,
    payload,
  }
}